/**
 * Copyright (C) 2025 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */
import { Box } from '@mui/material';
import React, { useCallback, useContext } from 'react';

import { useDispatch } from 'react-redux';
import { selectGpsSaMapLayersChecked } from '../../../store';
import appTheme from '../../common/theme/appTheme.json';
import { MapActionsContext, useSelectorWithMapId } from '../map/BaseMapContainer';
import OverlayToggle from './OverlayToggle';
import { requestGpsSaMapLayers } from '../../../store/gpsSa/actions';

const GpsSaMapLayerControl = () => {
  const dispatch = useDispatch();

  const mapActionsContext = useContext(MapActionsContext);
  const {
    setGpsSaMapLayersChecked,
    setGpsSaMapLayersNormalAccuracyChecked,
    setGpsSaMapLayersReducedAccuracyChecked,
    setGpsSaMapLayersLowAccuracyChecked,
  } = mapActionsContext.mapActions;

  const gpsSaMapLayersChecked = useSelectorWithMapId(selectGpsSaMapLayersChecked);

  const setChecked = useCallback(
    (checked: boolean) => {
      // Turn the GPS SA map layers on/off
      dispatch(setGpsSaMapLayersChecked(checked));

      // Request the GPS SA map layers if they are turned on
      if (checked) {
        dispatch(requestGpsSaMapLayers());
      }

      // Show/hide all the GPS SA map layers
      dispatch(setGpsSaMapLayersNormalAccuracyChecked(checked));
      dispatch(setGpsSaMapLayersReducedAccuracyChecked(checked));
      dispatch(setGpsSaMapLayersLowAccuracyChecked(checked));
    },
    [
      dispatch,
      setGpsSaMapLayersChecked,
      setGpsSaMapLayersNormalAccuracyChecked,
      setGpsSaMapLayersReducedAccuracyChecked,
      setGpsSaMapLayersLowAccuracyChecked,
    ],
  );

  return (
    <OverlayToggle
      checked={gpsSaMapLayersChecked}
      setChecked={setChecked}
      toggleId="gpsSaMapLayersToggle"
      disabled={false}
      label={
        <Box component="span" color={appTheme.primaryTextColor} fontSize="12px">
          GPS POSITION ACCURACY
        </Box>
      }
    />
  );
};
export default GpsSaMapLayerControl;
